module.exports = __webpack_public_path__ + "39e4ccb5615daed8283d60d3fcae308d.png";